<template>
  <PageShell :background="background">
    <PageHeader :eyebrow="'404'" :title="t('notFound.title')" :lead="t('notFound.message')">
      <template #actions>
        <LandingButton variant="accent" :to="{ name: 'Home' }">{{ t('notFound.backHome') }}</LandingButton>
        <LandingButton variant="ghost" :to="{ name: 'WhatIsIt' }">{{ t('notFound.startHere') }}</LandingButton>
      </template>
    </PageHeader>
  </PageShell>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import PageShell from '@/components/public/PageShell.vue';
import PageHeader from '@/components/public/PageHeader.vue';
import LandingButton from '@/components/btn/LandingButton.vue';
import background from '@/assets/images/backgrounds/jonnie-404.webp';

const { t } = useI18n();
</script>
